import React from "react";
import AsianEventMarketPeriod from "../../../AsianEventMarketPeriod/AsianEventMarketPeriod";

const AsianEventCellHDP = (props: Record<string, any>): React.JSX.Element => {
  const { marketPeriods, event, highestNumberOfMarkets } = props;
  return (
    <React.Fragment>
      {marketPeriods &&
        marketPeriods.map(marketPeriod => {
          return (
            <div
              className="asian-marketPeriod-container"
              key={
                event.id +
                "_" +
                marketPeriod.marketPeriod +
                "_" +
                marketPeriod.marketPeriod
              }
            >
              <AsianEventMarketPeriod
                key={
                  "AsianEventMarketPeriod_" +
                  event.id +
                  "_" +
                  marketPeriod.marketPeriod +
                  "_" +
                  marketPeriod.marketPeriod
                }
                marketPeriod={marketPeriod}
                event={event}
                highestNumberOfMarkets={highestNumberOfMarkets}
              />
            </div>
          );
        })}
    </React.Fragment>
  );
};

export default AsianEventCellHDP;
